import ReactDOM from 'react-dom/client';
import './index.css';
import App from './components/App/App';
import { ProductIdType } from './types';
import App2 from './components/App/App2';

const ElementInfo = [
  { elementId: 'root', appType: 'App' },
  { elementId: 'root2', appType: 'App' },
  { elementId: 'root3', appType: 'App' },
  { elementId: 'root4', appType: 'App2' },
  { elementId: 'root5', appType: 'App2' },
  { elementId: 'root6', appType: 'App2' },
  { elementId: 'root7', appType: 'App2' },
  { elementId: 'root8', appType: 'App2' },
] as const;

ElementInfo.forEach(({ elementId, appType }) => {
  const rootElement = document.getElementById(elementId) as HTMLElement;
  if (rootElement) {
    const productsId: ProductIdType[] =
      rootElement.getAttribute('data-sku')?.replace(/\s+/g, '').split(',') ??
      [];

    const isTwoItems = rootElement.getAttribute('data-two-items');
    const root = ReactDOM.createRoot(rootElement);

    if (appType === 'App') {
      root.render(<App productsId={productsId} />);
    }

    if (appType === 'App2') {
      root.render(<App2 productsId={productsId} isTwoItems={!!isTwoItems} />);
    }
  }
});

// const rootElement = document.getElementById('root') as HTMLElement;
// const rootElement2 = document.getElementById('root2') as HTMLElement;
// const rootElement3 = document.getElementById('root3') as HTMLElement;
// const rootElement4 = document.getElementById('root3') as HTMLElement;
// const rootElement5 = document.getElementById('root3') as HTMLElement;
// const rootElement6 = document.getElementById('root3') as HTMLElement;
// const productsId: ProductIdType[] =
//   rootElement.getAttribute('data-sku')?.replace(/\s+/g, '').split(',') ?? [];

// const root = ReactDOM.createRoot(rootElement);

// root.render(<App productsId={productsId} />);

// if (rootElement2) {
//   const productsId2: ProductIdType[] =
//     rootElement2?.getAttribute('data-sku')?.replace(/\s+/g, '').split(',') ??
//     [];

//   const root2 = ReactDOM.createRoot(rootElement2);
//   root2.render(<App productsId={productsId2} />);
// }

// if (rootElement3) {
//   const productsId2: ProductIdType[] =
//     rootElement2?.getAttribute('data-sku')?.replace(/\s+/g, '').split(',') ??
//     [];

//   const root2 = ReactDOM.createRoot(rootElement2);
//   root2.render(<App productsId={productsId2} />);
// }

// if (rootElement4) {
//   const productsId3: ProductIdType[] =
//     rootElement3?.getAttribute('data-sku')?.replace(/\s+/g, '').split(',') ??
//     [];
//   const isTwoItems = rootElement3.getAttribute('data-two-items');

//   const root3 = ReactDOM.createRoot(rootElement3);
//   root3.render(<App2 productsId={productsId3} isTwoItems={!!isTwoItems} />);
// }

// if (rootElement5) {
//   const productsId3: ProductIdType[] =
//     rootElement3?.getAttribute('data-sku')?.replace(/\s+/g, '').split(',') ??
//     [];
//   const isTwoItems = rootElement3.getAttribute('data-two-items');

//   const root3 = ReactDOM.createRoot(rootElement3);
//   root3.render(<App2 productsId={productsId3} isTwoItems={!!isTwoItems} />);
// }

// if (rootElement6) {
//   const productsId3: ProductIdType[] =
//     rootElement3?.getAttribute('data-sku')?.replace(/\s+/g, '').split(',') ??
//     [];
//   const isTwoItems = rootElement3.getAttribute('data-two-items');

//   const root3 = ReactDOM.createRoot(rootElement3);
//   root3.render(<App2 productsId={productsId3} isTwoItems={!!isTwoItems} />);
// }
